import { v4 as uuidv4 } from 'uuid';
const uuid = uuidv4();

export const getIsOptimizelyTrue = async (featureName, variableName, userId = uuid) => {
  const url = `${process.env.BASE_URL}/${process.env.V_PREFIX}/optimizely/userId/${userId}?featureName=${featureName}&variableName=${variableName}&api_key=${process.env.API_KEY}`;
  const response = await fetch(url, {
    headers: {
      referer: `${process.env.BASE_URL}`,
      authorization: `Basic ${process.env.ICO_TOKEN}`,
    },
    method: 'GET',
    mode: 'cors',
  });
  return response.json();
};

export const getAllOptimizelyVariables = (featureNames, userId) => {
  let url = `${process.env.BASE_URL}/${process.env.V_PREFIX}/optimizely/userId/${userId}?api_key=${process.env.API_KEY}`;
  featureNames.forEach((featureName) => (url = `${url}&featureNames=${featureName}`));
  return fetch(url, {
    headers: {
      referer: `${process.env.BASE_URL}`,
      authorization: `Basic ${process.env.ICO_TOKEN}`,
    },
    method: 'GET',
    mode: 'cors',
  })
    .then((res) => res.json())
    .then((res) => res.data);
};

export const triggerCustomEvent = (eventName, featureName, userId = uuid) => {
  const url = `${process.env.BASE_URL}/${process.env.V_PREFIX}/optimizely/userId/${userId}?featureName=${featureName}&eventName=${eventName}&api_key=${process.env.API_KEY}`;

  return fetch(url, {
    headers: {
      referer: `${process.env.BASE_URL}`,
      authorization: `Basic ${process.env.ICO_TOKEN}`,
    },
    method: 'GET',
    mode: 'cors',
  })
    .then((res) => res.json())
    .then((res) => res.data);
};
